/* eslint-disable @typescript-eslint/naming-convention */
import * as ls from 'local-storage'

import { local_storage_key } from '@common/constants'
import EthereumNetwork from '@providers/EthereumNetwork'
import { THandleConnectWalletController } from '@providers/models'
import PolygonNetwork from '@providers/PolygonNetwork'

export const handleConnectWallet = async (
    provider: EthereumNetwork | PolygonNetwork,
    chainId: number,
): Promise<THandleConnectWalletController> => {
    await provider.disconnect()
    const web3 = provider.getCurrentProvider()

    const isConnected = await provider.connect()
    try {
        await provider.getCurrentChainId(chainId)
    } catch {
        console.log('error getCurrentChainId')
    }

    if (isConnected) {
        ls.set(local_storage_key.KEY_CONNECTED, 1)
        const accounts = await provider.getCurrentAccount()
        if (accounts.length > 0) {
            const balance = await web3.eth.getBalance(accounts[0])

            return {
                success: true,
                data: {
                    balance: web3.utils.fromWei(balance, 'ether'),
                    accounts,
                },
                message: 'Connected to wallet',
            }
        } else {
            return {
                success: false,
                error: 'Connecting wallet failed',
            }
        }
    } else {
        return {
            success: false,
            error: 'Connecting wallet failed',
        }
    }
}
